/**
 * Created by xixue on 2018/9/30.
 */
const rootUrl = window.location.host
let socketHost = ''
let reportHost = ''

switch (rootUrl) {
    case 'study.classba.cn':
    case 'study.171xue.com':
      socketHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'socket.classba.cn'
      reportHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'report.classba.cn/study'
      break
    default:
      socketHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'test-socket.classba.cn'
      reportHost = (window.location.protocol === 'https:' ? 'https://' : 'http://') + 'report.test.classba.cn/study'
}

export { socketHost,reportHost }



// WEBPACK FOOTER //
// ./src/utils/hostsconfig.js